import React, { useState } from 'react';
import Moment from 'moment';
import ProgressPhotosView from './ProgressPhotosView';

const ProgressPhotosRow = ({ date, images }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [photo, setPhoto] = useState();

  const created_at = date.toDate
    ? Moment(date.toDate()).format('MM/DD/YYYY')
    : '';

  return (
    <div className="photos-row">
      <header>{created_at}</header>
      <div className="progress-img">
        <div>
          <img
            src={images.front}
            alt="Progress"
            onClick={() => {
              setModalOpen(true);
              setPhoto(images.front);
            }}
          />
        </div>
        <div>
          <img
            src={images.side}
            alt="Progress"
            onClick={() => {
              setModalOpen(true);
              setPhoto(images.side);
            }}
          />
        </div>
        <div>
          <img
            src={images.back}
            alt="Progress"
            onClick={() => {
              setModalOpen(true);
              setPhoto(images.back);
            }}
          />
        </div>
      </div>
      <ProgressPhotosView
        photo={photo}
        openModal={modalOpen}
        setModalOpen={setModalOpen}
      />
    </div>
  );
};

export default ProgressPhotosRow;
